<template>
  <div class="blog-container">
    <HundredItem
      v-for="item in itemList"
      :key="item.id"
      :every="item"
      :curcer="item.articleId"
      @itemClick="goDetail"
    ></HundredItem>
    <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
  </div>
</template>

<script>
import HundredItem from "@/components/pager/HundredItem.vue";
import mixin from "@/mixins/scrollPager";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    HundredItem,
    Scroll
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        id: this.$route.query.id,
        pageNo: 1,
        pageSize: 10,
        userType: 1,
      },
    };
  },
  created() {
    this.getList(this.params);
  },
  methods: {
    async getList(data) {
      this.scrollFlag = true;
      const resp = await this.$apis.hundredServe.getBlogList(data);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 10;
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/msgDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-container {
  background-color: #fff;
  min-height: 700px;
  // padding: 0 49px 19px 37px;
  padding-bottom: 37px;
}
</style>
